import { render, staticRenderFns } from "./PraiseList.vue?vue&type=template&id=4c5c60e3&scoped=true&"
import script from "./PraiseList.vue?vue&type=script&lang=js&"
export * from "./PraiseList.vue?vue&type=script&lang=js&"
import style0 from "./PraiseList.vue?vue&type=style&index=0&id=4c5c60e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c60e3",
  null
  
)

export default component.exports